/* istanbul ignore file */
export enum GrowlActionTypesEnum {
	SHOW_MESSAGE = 'growl/show-message',
	HIDE_MESSAGE = 'growl/hide-message'
}
